import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#331B65',
    },
    secondary: {
      main: '#2A1C50',
    },
    background: {
      default: '#0B1016',
    },
  },
});

export const CustomThemeProvider = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

